import Noty from "noty";
import { merge } from "lodash-es";

/*
 * opts params
 *   layout: '' // default topRight
 */
export const success = function(text, opts = {}) {
  opts = merge(
    {
      theme: "nest",
      type: "success",
      text: text,
      timeout: 3000,
      layout: "topRight"
    },
    opts
  );
  return new Noty(opts).show();
};

/*
 * opts params
 *   layout: '' // default topRight
 */
export const error = function(text, opts = {}) {
  opts = merge(
    {
      theme: "nest",
      type: "error",
      text: text,
      timeout: 3000,
      layout: "topRight"
    },
    opts
  );
  return new Noty(opts).show();
};

/*
 * opts params
 *   layout: '' // default topRight
 */
export const info = function(text, opts = {}) {
  opts = merge(
    {
      theme: "nest",
      type: "info",
      timeout: 3000,
      text: text,
      layout: "topRight"
    },
    opts
  );
  return new Noty(opts).show();
};

export const warning = function(text, opts = {}) {
  opts = merge(
    {
      theme: "nest",
      type: "warning",
      timeout: 3000,
      text: text,
      layout: "topRight"
    },
    opts
  );
  return new Noty(opts).show();
};
